import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './CountdownTimer.css';

const targetDate = new Date('2027-06-02T00:00:00');

function getTimeLeft() {
  const now = new Date();
  const difference = targetDate - now;

  const totalSeconds = Math.max(0, Math.floor(difference / 1000));

  return {
    days: Math.floor(totalSeconds / (3600 * 24)),
    hours: Math.floor((totalSeconds % (3600 * 24)) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

// Calculate stroke dashoffset for circle progress
function calculateDashOffset(value, max) {
  const circumference = 2 * Math.PI * 45; // r=45
  return circumference - (value / max) * circumference;
}

export default function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="circular-countdown-container">
      <h2>Counting down to the special day </h2>
      <div className="rings-container">

        {/* Days */}
        <div className="ring-wrapper">
          <svg width="120" height="120" className="ring-svg">
            <circle className="ring-bg" cx="60" cy="60" r="45" />
            <motion.circle
              className="ring-progress days"
              cx="60"
              cy="60"
              r="45"
              strokeDasharray={2 * Math.PI * 45}
              strokeDashoffset={calculateDashOffset(timeLeft.days, 365)}
              initial={{ strokeDashoffset: 2 * Math.PI * 45 }}
              animate={{ strokeDashoffset: calculateDashOffset(timeLeft.days, 365) }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
          </svg>
          <div className="ring-label">
            <strong>{timeLeft.days}</strong>
            <span>Days</span>
          </div>
        </div>

        {/* Hours */}
        <div className="ring-wrapper">
          <svg width="120" height="120" className="ring-svg">
            <circle className="ring-bg" cx="60" cy="60" r="45" />
            <motion.circle
              className="ring-progress hours"
              cx="60"
              cy="60"
              r="45"
              strokeDasharray={2 * Math.PI * 45}
              strokeDashoffset={calculateDashOffset(timeLeft.hours, 24)}
              initial={{ strokeDashoffset: 2 * Math.PI * 45 }}
              animate={{ strokeDashoffset: calculateDashOffset(timeLeft.hours, 24) }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
          </svg>
          <div className="ring-label">
            <strong>{timeLeft.hours}</strong>
            <span>Hours</span>
          </div>
        </div>

        {/* Minutes */}
        <div className="ring-wrapper">
          <svg width="120" height="120" className="ring-svg">
            <circle className="ring-bg" cx="60" cy="60" r="45" />
            <motion.circle
              className="ring-progress minutes"
              cx="60"
              cy="60"
              r="45"
              strokeDasharray={2 * Math.PI * 45}
              strokeDashoffset={calculateDashOffset(timeLeft.minutes, 60)}
              initial={{ strokeDashoffset: 2 * Math.PI * 45 }}
              animate={{ strokeDashoffset: calculateDashOffset(timeLeft.minutes, 60) }}
              transition={{ duration: 1, ease: "easeOut" }}
            />
          </svg>
          <div className="ring-label">
            <strong>{timeLeft.minutes}</strong>
            <span>Minutes</span>
          </div>
        </div>

        {/* Seconds */}
        <div className="ring-wrapper">
          <svg width="120" height="120" className="ring-svg">
            <circle className="ring-bg" cx="60" cy="60" r="45" />
            <motion.circle
              className="ring-progress seconds"
              cx="60"
              cy="60"
              r="45"
              strokeDasharray={2 * Math.PI * 45}
              strokeDashoffset={calculateDashOffset(timeLeft.seconds, 60)}
              initial={{ strokeDashoffset: 2 * Math.PI * 45 }}
              animate={{ strokeDashoffset: calculateDashOffset(timeLeft.seconds, 60) }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            />
          </svg>
          <div className="ring-label">
            <strong>{timeLeft.seconds}</strong>
            <span>Seconds</span>
          </div>
        </div>

      </div>
    </div>
  );
}
